<template>
  <div class="search" >
    <v-text-field @input="handleSearch" @click:clear="handleClear" v-model="searchField" solo :clearable="true" :hide-details="true" append-icon="search" placeholder="Search by Serial Number or Extended ID">
    </v-text-field>
  </div>
</template>

<script>

import { debounce } from 'debounce'

export default {
  name: 'SearchInput',
  props: ['search'],
  data () {
    return {
      searchField: this.search
    }
  },
  watch: {
    search () {
      this.searchField = this.search
    }
  },
  methods: {
    handleClear () {
      this.$emit('on-clear')
    }
  },
  created () {
    let that = this
    this.handleSearch = debounce((e) => {
      that.$emit('on-search', this.searchField)
    }, 500)
  }
}

</script>

<style lang="scss" scoped>

.search{
  padding: 20px 15px 0px 15px;
}

</style>
